<template>
  <div class="subitem">
    <a class="item-url" :href="subitem.url">
      <div class="item-wrapper">
        <div
          v-if="subitem.image"
          class="img-wrapper lazyload"
          :data-bgset="subitem.image"
          data-sizes="auto"
        ></div>
        <div class="img-wrapper empty" v-else />
        <span>{{ subitem.title }}</span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    subitem: { type: Object, required: true }
  }
};
</script>

<style lang="scss" scoped>
a.item-url {
  color: $white;
  height: 100%;

  @include res(tab-l) {
    color: $medium-grey;
  }

  &:active,
  &:focus,
  &:visited {
    color: $white;

    @include res(tab-l) {
      color: $brown;
    }
  }
}
.subitem {
  margin: 0;
  list-style: none;

  @include ie {
    max-width: 250px;
    height: 250px;
    margin: 5px;
  }

  &:not(:last-child) {
    @include res(tab-l) {
      border-bottom: 1px solid #eeeeee;
    }
  }

  .item-wrapper {
    width: 100%;
    height: 0%;
    padding-top: 100%;
    background-color: $grey;
    position: relative;

    @include res(tab-l) {
      background-color: transparent;
      padding-top: unset;
    }

    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 2;
      background-color: $medium-grey;
      opacity: 0.7;
      display: none;

      @include res(tab-l) {
        opacity: 1;
        z-index: -1;
      }
    }

    &:hover {
      &::before {
        display: block;
      }
      span {
        color: $white;
      }
    }

    .img-wrapper {
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      position: relative;
      position: absolute;
      top: 0;

      @include res(tab-l) {
        display: none;
      }
    }

    span {
      position: absolute;
      color: $white;
      font-size: 12px;
      font-family: $font-text-heavy;
      font-weight: lighter;
      z-index: 4;
      top: 20px;
      width: 100%;
      text-align: center;

      @include res(tab-l) {
        color: $dark-grey;
        position: initial;
        padding-left: 20px;
        font-size: 15px;
        display: inline-block;
        text-align: left;
        line-height: 20px;
        font-family: $font-text;
        padding: 25px 0 25px 25%;
      }
    }
  }
}
.subitem-mobile {
  display: none;
  margin: 15px 0;
  padding-left: 25px;

  @include res(tab-l) {
    display: block;
  }
}
</style>
